module.exports = __webpack_public_path__ + "img/card_reembolso_pago_directo.80fdd88a.svg";